import { InjectionToken } from '@angular/core';

import { environment, EnvironmentName } from '@drf/environments';

export const CONSOLE_LOGGER_ENABLED = new InjectionToken<boolean>('Console logger enabled', {
  providedIn: 'root',
  factory: () => environment.envName === EnvironmentName.Local || environment.envName === EnvironmentName.Development,
});
